module.exports = __webpack_public_path__ + "img/Lato-Black.59a6d57b.svg";